import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  clinicId: yup.number().required(),
  patientId: yup.number().required(),
});

export function useChangeClinicMutation({
  onSuccess,
  onError,
  onMutate,
  onSettled,
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return http.post(HTTP_ENDPOINTS.patient.saveClinic(), {
        clinic_id: req.clinicId,
        patient_id: req.patientId,
      });
    },
    onMutate: () => {
      onMutate?.();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.client],
      });
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
    onSettled: () => {
      onSettled?.();
    },
  });
}
